module.exports = __webpack_public_path__ + "f9f56da15fbab1fe9f6a143e6f5f8278.svg";